import { axios } from "../../lib/axios";

export const DeleteCourseFromStudent = ({ studentId, courseId }: { studentId: string; courseId: string }) => {
    return axios.delete(`student/deleteStudentFromCourse/${studentId}/${courseId}`)
        .then(response => response.data);
};